import { getClientFormsForSignature } from "api/customers";
import { useQuery } from "react-query";

// Custom hook to fetch forms needing signature from client
const useGetClientFormsForSignature = (
  clientId,
  enabled = true,
  query = {},
  queryOptions = {}
) => {
  const { queryKeySuffix, ...options } = queryOptions;
  const queryKey = queryKeySuffix
    ? ["unsignedForms", clientId, queryKeySuffix]
    : ["unsignedForms", clientId];
  const { data, error, isLoading, refetch } = useQuery(
    queryKey,
    () => getClientFormsForSignature(clientId, query),
    {
      ...options,
      select: (data) => data?.data,
      enabled: enabled,
    }
  );

  return { forms: data ?? [], isLoading, error, refetch };
};

export default useGetClientFormsForSignature;
